import react  from '../img/skilla/react.svg'
import node  from '../img/skilla/node.svg'
import mongo  from '../img/skilla/mongoDB.svg'
import Angular  from '../img/skilla/angular.png'
import pyhon  from '../img/skilla/python.svg'
import django  from '../img/skilla/django.svg'
import mysql  from'../img/skilla/mysql.svg'
import html  from '../img/skilla/html.svg'
import js  from '../img/skilla/javascript.svg'
import css  from '../img/skilla/css.svg'
import bootstrap  from '../img/skilla/bootstrap.svg'
import git  from '../img/skilla/git.svg'
import Tailwind from '../img/skilla/tailwind.svg'
import postman from '../img/skilla/postman.png'
import restapi from '../img/skilla/api.png'

export const skillData = [
    {
        id: 1,
        title: 'React Js',
        icon:react
       
    },
    {
        id: 2,
        title: 'Node',
        icon:node
    },
    {
        id: 3,
        title: 'MongoDb',
        icon:mongo
       
    },
    {
        id: 5,
        title: 'Python',
        icon:pyhon
    },

    {
        id: 6,
        title: 'Django',
        icon: django
    },
    {
        id: 7,
        title: 'MySql',
        icon:mysql
    },
    {
        id: 8,
        title: 'Html',
        icon: html
    }, 
    {
        id: 9,
        title: 'JavaScript',
        icon: js
    },
    {
        id: 10,
        title: 'CSS', 
        icon: css
    },
    {
        id: 11,
        title: 'BootStrap',
        icon: bootstrap
    },
     {
        id: 12,
        title: 'Tailwind CSS',
        icon: Tailwind
    },
    {
        id: 13,
        title: 'Git',
        icon: git
    },
    {
        id:14,
        title:'Angular.js',
        icon: Angular

    },
    {
        id:15,
        title:'Postman',
        icon: postman

    },
    {
        id:16,
        title:'Rest Framework',
        icon: restapi

    }


   

]
